import React from 'react'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Form, InputNumber, Tooltip } from 'antd'
import styles from './CustomInputTotalAmount.module.scss'

const CustomInputTotalAmount = (props) => {
  const { t } = useTranslation()
  const {
    required = false,
    placeholder, name,
    handleToggleClick = null,
    toogleText = '',
    onChange = null,
    max = null
  } = props

  const tooltipButton = (
    <Tooltip title={toogleText} color={'blue'}>
      <Button
        type='primary'
        htmlType='submit'
        shape='circle'
        onClick={handleToggleClick}
        className='radius-100'
        icon={<PlusOutlined />}
      />
    </Tooltip>
  )

  const hasTooltip = () => handleToggleClick !== null

  const handleOnChange = (value: any) => {
    if (onChange !== null) {
      onChange(value)
    }
  }

  return (
    <>
      <Form.Item
        name={name}
        rules={[
          { required, message: t(`general.RequiredValidation`) },
          { type: 'number',min: 5, message: t('Summary.MinimumValidation') }

        ]}
      >
        <InputNumber
          type='number'
          onChange={handleOnChange}
          placeholder={placeholder}
          className={styles['custom-input-number']}
          size='large'
          addonAfter={hasTooltip() ? tooltipButton : null}
          min={0}
          max={max}
          step={'0.01'}
          value={5}
        />
      </Form.Item>
    </>
  )
}

export default CustomInputTotalAmount
